// extracted by mini-css-extract-plugin
export default {"logo":"AuthenticationView__logo____VUUY"};